export default __webpack_public_path__ + "locales/zh-CN/Settings.json?hash=f0d21640a30de5da53de80387f57d65c";